import React, { Component } from "react";
import _ from "lodash";
import AUX from "../../hoc/Aux_";
import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import axios from "../Shared/auth-header";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Accordion, Card, Button, Dropdown } from "react-bootstrap";
import TableCustomTotal from "../Shared/TableCustomTotal";
import EmailListMemType from "../Email/Enums/EmailListMemType";
import { Spinner } from "reactstrap";
import EmailListService from "../Email/EmailListService";
import AddRecptType from "../Email/Enums/AddRecptType";
import MailingListMembersTables from "../Email/Enums/MailingListMembersTables";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import mailGunEmailActions from "../../store/mailgunEmails/action";
import { connect } from "react-redux";
import MG_ReSubscriberModal from "../Email/ModalPopups/MG_ReSubscriberModal";
import { toast } from "react-toastify";
import AuthService from "../../modules/Auth/AuthService";
import PermissionFeature from "../../modules/Permissions/PermissionFeature";
//import overlayFactory from "react-bootstrap-table2-overlay";
import { Table } from "react-bootstrap";
import RemoveActionType from "../Email/Enums/RemoveActionType";
import EmailConfigTables from "../Email/Enums/EmailConfigTables";

const NoDataIndication = () => (
  <div class="container h-100">
    <div class="row NoDataFoundTable">
      <h5>No Data Found!</h5>
    </div>
  </div>
);
const CaptionElement = (props) => (
  <h6 className="sub_tbl_caption">{props.header}</h6>
);

const Empty = () => <div />;
class MailGunMembersList extends Component {
  constructor(props) {
    super(props);
    let pagingModel = {
      currentPage: 1,
      pageSize: 25,
      orderBy: "name",
      sortOrder: "asc",
    };

    this.state = {
      loadingUnSubs: false,
      loadingSubs: false,
      loadingNonNatcaUnSubs: false,
      loadingAdditionalTeamUnSubs: false,
      mgListAddress: props.mgListAddress,
      subscribers: [],
      totalSubscribers: 0,
      unsubscribers: [],
      totalUnsubscribers: 0,
      nonNatcaUnSubscribers: [],
      additionalTeamUnSubscribers: [],
      totalNonNatcaUnsubscribers: 0,
      totalAdditionalTeamUnSubscribers: 0,
      currentPage: 1,
      pageSize: 25,
      sortOrder: "asc",
      orderBy: "name",
      listPaging: {
        sub: { ...pagingModel },
        unsub: { ...pagingModel },
      },
      columns: [
        { text: "Name", dataField: "name", sort: true },
        { text: "Email", dataField: "address", sort: true },
        { text: "Facility", dataField: "facilityRegion", sort: false },
      ],
      teamColumns: [{ text: "Name", dataField: "teamName", sort: true }],
      paginationSettings: {
        showTotal: true,
      },
      subSearchText: "",
      unsubSearchText: "",
      nonNatcaUnsubSearchText: "",
      toggleUNSUB: false,
      toggleSUB: true,
      allDefaultSubscribers: [],
      allDefaultUnSubscribers: [],
      allDefaultNonNatcaUnSubscribers: [],
      allDefaultAdditionalTeamUnSubscribers: [],
      resubscribeEmail: "",
      showReSubscribeModal: false,
      unSubTeam: "",
      unSubTeamId: 0,
      teamMembers: [],
      teamMapId: 0,
    };
    this.confirmResubscribersModal = () => {
      this.confirmed = () => {
        this.showSpinner();
        let url = (url = `/api/MailGun/ResubscribeMember?mailAddress=${this.props.mgListAddress}&email=${this.state.resubscribeEmail}`);
        axios
          .put(url)
          .then(({ data: resp }) => {
            if (resp.status.toLowerCase() == "success") {
              ///this.updateData();
              if (
                this.props.emailListMemType == EmailListMemType.UnSubscribers
              ) {
                //Reload 2nd Tab's First Table i.e unSubscribers
                const unSubscribersListRef = this.props.unSubscribersListRef
                  .current;
                unSubscribersListRef.resetData();
                unSubscribersListRef.reload();
              } else if (
                this.props.emailListMemType ==
                EmailListMemType.NonNatcaUnSubscribers
              ) {
                const nonNatcaUnsubscribersListRef = this.props
                  .nonNatcaUnsubscribersListRef.current;
                nonNatcaUnsubscribersListRef.resetData();
                nonNatcaUnsubscribersListRef.reload();
              }

              //Reload First Table i.e Subscribers
              const subscribersListRef = this.props.subscribersListRef.current;
              subscribersListRef.reload();
              //Reload All Additional Subscriber
              //Tables(Addtl=> Members+Teams+NonNatca) on Subscribers Tabs
              this.props.reloadAdditionalSubsribersTables();
              this.toggleResubscribersModal();
            } else {
              toast.error("Something went wrong!");
            }
          })

          .catch((err) => {
            toast.error("Something went wrong!");
            this.hideSpinner();
          })
          .finally(() => {
            this.hideSpinner();
          });
      };

      return this;
    };

    this.confirmResubscribersModalForTeams = () => {
      this.confirmed = () => {
        this.showSpinner();
        let apiParams = {
          mailingListAddress: this.props.mgListAddress,
          TeamId: this.state.unSubTeamId,
          teamMembers: this.state.teamMembers,
          teamMapId: this.state.teamMapId,
        };
        let url = `/api/MailGun/ResubscribeTeam`;
        axios
          .put(url, apiParams)
          .then(({ data: resp }) => {
            if (resp.status.toLowerCase() == "success") {
              ///this.updateData();

              //Reload First Table i.e Subscribers
              const additionalTeamUnsubscribersListRef = this.props
                .additionalTeamUnsubscribersListRef.current;
              additionalTeamUnsubscribersListRef.reload();
              //Reload All Additional Subscriber
              //Tables(Addtl=> Members+Teams+NonNatca) on Subscribers Tabs
              this.props.reloadAdditionalSubsribersTables();
              this.toggleResubscribersModal();
            } else {
              toast.error("Something went wrong!");
            }
          })

          .catch((err) => {
            toast.error("Something went wrong!");
            this.hideSpinner();
          })
          .finally(() => {
            this.hideSpinner();
          });
      };

      return this;
    };
  }

  componentDidMount = () => {
    // console.log("state email" + this.state.mgListAddress);
    // console.log("props email" + this.props.mgListAddress);
    this.reload();
  };

  reload = () => {
    this.updateData();
  };
  resetData = () => {
    if (this.props.emailListMemType == EmailListMemType.Subscribers) {
      this.setState({ subscribers: [] });
    } else if (this.props.emailListMemType == EmailListMemType.UnSubscribers) {
      this.setState({ unsubscribers: [] });
    } else if (
      this.props.emailListMemType == EmailListMemType.NonNatcaUnSubscribers
    ) {
      this.setState({ nonNatcaUnSubscribers: [] });
    }
  };
  showSpinner = () => {
    $(".loading").show();
  };

  hideSpinner = () => {
    $(".loading").hide();
  };

  handleClose = () => {
    this.props.onModalClose();
  };

  updateSubscriberList = async (pagingDetail) => {
    // let { subSearchText } = this.state;

    let subscribersTablesTypes = [MailingListMembersTables.DefaultSubscribers];

    let params = {
      // ...pagingDetail,
      //  subSearchText,
      subscribersTablesTypes,
      mgListAddress: this.props.mgListAddress,
    };
    this.setState({
      loadingSubs: true,
    });
    await EmailListService.updateSubscriberList(params).then(
      ({ data: resp }) => {
        // this.hideSpinner();
        //console.log("params", JSON.stringify(params));
        if (resp.success) {
          this.setTableStateData(resp.data);
        }
        this.setState({
          loadingSubs: false,
        });
      }
    );
  };
  setTableStateData = (stateData) => {
    stateData.forEach((element) => {
      if (element.type == MailingListMembersTables.DefaultSubscribers) {
        this.setState({
          subscribers: element.data.memberResultSet || [],
          totalSubscribers: element.data.totalRecordsCount,
          loadingSubs: false,
          allDefaultSubscribers: element.data.memberResultSet || [],
        });
      } else if (
        element.type == MailingListMembersTables.DefaultUnSubscribers
      ) {
        this.setState({
          unsubscribers: element.data.memberResultSet || [],
          totalUnsubscribers: element.data.totalRecordsCount,
          loadingUnSubs: false,
          allDefaultUnSubscribers: element.data.memberResultSet || [],
        });
      } else if (
        element.type == MailingListMembersTables.NonNatcaUnSubscribers
      ) {
        this.setState({
          nonNatcaUnSubscribers: element.data.memberResultSet || [],
          totalNonNatcaUnsubscribers: element.data.totalRecordsCount,
          loadingNonNatcaUnSubs: false,
          allDefaultNonNatcaUnSubscribers: element.data.memberResultSet || [],
        });
      } else if (
        element.type == MailingListMembersTables.AdditionalTeamUnSubscribers
      ) {
        this.setState({
          additionalTeamUnSubscribers: element.data.teamResultSet || [],
          totalAdditionalTeamUnSubscribers: element.data.totalRecordsCount,
          loadingAdditionalTeamUnSubs: false,
          allDefaultAdditionalTeamUnSubscribers:
            element.data.teamResultSet || [],
        });
      } else if (
        element.type == MailingListMembersTables.AdditionalMemberRecipients
      ) {
        this.props.setAddlSubscribers(
          element.data.memberResultSet || [],
          AddRecptType.Member
        );
      } else if (
        element.type == MailingListMembersTables.AdditionalTeamRecipients
      ) {
        this.props.setAddlSubscribers(
          element.data.teamResultSet || [],
          AddRecptType.Team
        );
      } else if (
        element.type == MailingListMembersTables.AdditionalNonNatcaRecipients
      ) {
        this.props.setAddlSubscribers(
          element.data.memberResultSet || [],
          AddRecptType.NonNatca
        );
      }
      this.props.setAddlSubscribers([], AddRecptType.All);
    });
  };

  updateUnsubscriberList = async (pagingDetail) => {
    //let { unsubSearchText } = this.state;
    let unSubscribersTablesTypes = [
      MailingListMembersTables.DefaultUnSubscribers,
    ];
    let params = {
      // ...pagingDetail,
      //unsubSearchText,
      unSubscribersTablesTypes,
      mgListAddress: this.props.mgListAddress,
    };
    //this.showSpinner();
    this.setState({
      loadingUnSubs: true,
    });
    await EmailListService.updateUnsubscriberList(params).then(
      ({ data: resp }) => {
        /// this.hideSpinner();
        if (resp.success) {
          this.setTableStateData(resp.data);
        } else {
          this.setState({
            loadingUnSubs: false,
          });
        }
      }
    );
  };
  toggleResubscribersModal = () => {
    this.setState({
      showReSubscribeModal: !this.state.showReSubscribeModal,
    });
  };
  updateNonNatcaUnsubscriberList = async (pagingDetail) => {
    // let { unsubSearchText } = this.state;
    let unSubscribersTablesTypes = [
      MailingListMembersTables.NonNatcaUnSubscribers,
    ];
    let params = {
      ...pagingDetail,
      //  unsubSearchText,
      unSubscribersTablesTypes,
      mgListAddress: this.props.mgListAddress,
    };

    //this.showSpinner();
    this.setState({
      loadingNonNatcaUnSubs: true,
    });
    await EmailListService.updateUnsubscriberList(params).then(
      ({ data: resp }) => {
        /// this.hideSpinner();
        if (resp.success) {
          this.setTableStateData(resp.data);
        }
        this.setState({
          loadingNonNatcaUnSubs: false,
        });
      }
    );
  };
  updateAdditionalTeamsUnsubscriberList = async () => {
    // let { unsubSearchText } = this.state;
    let unSubscribersTablesTypes = [
      MailingListMembersTables.AdditionalTeamUnSubscribers,
    ];
    let params = {
      //...pagingDetail,
      //  unsubSearchText,
      unSubscribersTablesTypes,
      mgListAddress: this.props.mgListAddress,
    };

    //this.showSpinner();
    this.setState({
      loadingAdditionalTeamUnSubs: true,
    });
    await EmailListService.updateUnsubscriberList(params).then(
      ({ data: resp }) => {
        /// this.hideSpinner();
        if (resp.success) {
          this.setTableStateData(resp.data);
        }
        this.setState({
          loadingAdditionalTeamUnSubs: false,
        });
      }
    );
  };
  updateData = () => {
    if (this.props.emailListMemType == EmailListMemType.Subscribers) {
      this.updateSubscriberList(this.state.listPaging["sub"]);
    } else if (this.props.emailListMemType == EmailListMemType.UnSubscribers) {
      this.updateUnsubscriberList(this.state.listPaging["unsub"]);
    } else if (
      this.props.emailListMemType == EmailListMemType.NonNatcaUnSubscribers
    ) {
      this.updateNonNatcaUnsubscriberList(this.state.listPaging["unsub"]);
    } else if (
      this.props.emailListMemType ==
      EmailListMemType.AdditionalTeamUnSubscribers
    ) {
      this.updateAdditionalTeamsUnsubscriberList(
        this.state.listPaging["unsub"]
      );
    }
  };

  renderSubscribed = (subscriberList, page, sizePerPage, loading) => {
    const sizePerPageList = [
      {
        text: "10",
        value: 10,
      },
      {
        text: "25",
        value: 25,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "All",
        value: subscriberList && subscriberList.length,
      },
    ];
    const Style = {
      overflow: "auto !important",
    };
    if (subscriberList != null) {
      const customTotal = (from, to, size) => (
        <span
          className="react-bootstrap-table-pagination-total"
          style={{ float: "left", marginTop: "3px", marginRight: "4px" }}
        >
          {from}
          {" - "}
          {to} of {size} {"   "}
          <b style={{ marginLeft: "4px" }}> Show: </b>
        </span>
      );
      return (
        <div
          className="table-responsive scroller"
          ref={(node) => {
            if (node) {
              node.style.setProperty("min-height", "auto", "important");
            }
          }}
          key={this.props.emailListMemType}
        >
          <ToolkitProvider
            keyField={`address`}
            data={subscriberList}
            columns={this.state.columns}
          >
            {(props) => (
              <>
                <BootstrapTable
                  noDataIndication={() => {
                    return loading === false ? (
                      <NoDataIndication />
                    ) : (
                      <div className="d-flex justify-content-center p-4">
                        <Spinner />
                      </div>
                    );
                  }}
                  pagination={paginationFactory({
                    ...{
                      paginationTotalRenderer: customTotal,
                      totalSize: subscriberList && subscriberList.length,
                      paginationTotalRenderer: TableCustomTotal,
                      showTotal: true,
                      page,
                      sizePerPage,
                      sizePerPageList,
                    },
                  })}
                  {...props.baseProps}
                />
              </>
            )}
          </ToolkitProvider>
        </div>
      );
    }
  };

  reSubscribe(row) {
    if (row.address) {
      this.setState({ resubscribeEmail: row.address });
      this.setState({ showReSubscribeModal: true });
    } else if (this.props.isTeamsTable) {
      this.setState({ unSubTeam: row.teamName });
      this.setState({ unSubTeamId: row.teamId });
      this.setState({ teamMembers: row.members });
      this.setState({ showReSubscribeModal: true });
      this.setState({ teamMapId: row.id });
    }
  }
  showDuplicateIcon = () => {
    return (
      <i
        className="fa fa-files-o"
        aria-hidden="true"
        title="Duplicate Email"
      ></i>
    );
  };
  expandRow = {
    parentClassName: "parent-expand",
    onlyOneExpanding: true,
    renderer: (row) => (
      <>
        {row.id ? (
          <div className="expandTbl">
            {!_.isEmpty(row.members) && (
              <>
                <div class="strong d-flex justify-content-center text-primary font-weight-bold ">
                  <h6>Team Members</h6>
                </div>
                <div class="d-flex justify-content-center equipExpandableView">
                  <Table>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {row.members.map((member, idx) => (
                        <tr key={idx}>
                          <td>{member.name}</td>
                          <td>
                            {member.address}{" "}
                            {member.isDuplicate == true
                              ? this.showDuplicateIcon()
                              : ""}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </>
            )}

            {_.isEmpty(row.members) && (
              <div class="container">
                <div class="row noADData">
                  <span>No Data to display!</span>
                </div>
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </>
    ),
  };
  ///######Will be both for (Non Natca/Default) UnSubscriber Members && ****Teams****####///
  renderUnsubscribed = (
    unsubscriberList,
    page,
    sizePerPage,
    loading,
    caption,
    hideActionColumn
  ) => {
    const sizePerPageList = [
      {
        text: "10",
        value: 10,
      },
      {
        text: "25",
        value: 25,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "All",
        value: unsubscriberList && unsubscriberList.length,
      },
    ];
    const Style = {
      overflow: "auto !important",
    };
    if (unsubscriberList != null) {
      let columnsToRender = {};
      if (caption == "TEAMS") {
        columnsToRender = [...this.state.teamColumns];
      } else {
        columnsToRender = [...this.state.columns];
      }

      let actionCol = {
        text: "Action",
        hidden: !hideActionColumn,
        formatter: (cell, row) => {
          return (
            <>
              <button
                type="button"
                class="btn btn-primary unsubscrActionBtn mr-1"
                onClick={() => {
                  this.reSubscribe(row);
                }}
              >
                ReSubscribe
                <i
                  className="fa fa-undo cursorPointer pl-1"
                  aria-hidden="true"
                  title="Re-subscribe"
                ></i>
              </button>

              {/* Trash-Bin Icon */}

              {(this.props.keyIdfr == EmailConfigTables.NonNatcaMembers ||
                this.props.keyIdfr ==
                  EmailConfigTables.AdditionalRecipientsTeam) && (
                <button
                  type="button"
                  className="btn btn-danger unsubscrActionBtn"
                  onClick={() => {
                    if (
                      this.props.emailListMemType ==
                      EmailListMemType.NonNatcaUnSubscribers
                    ) {
                      this.props.confirmDeleteMember(
                        row.id,
                        row.address,
                        EmailConfigTables.NonNatcaMembers,
                        RemoveActionType.Delete
                      );
                      this.props.setCurrentSenderInfo(
                        row.firstName,
                        row.lastName,
                        row.memberId,
                        RemoveActionType.Delete
                      );
                    } else {
                      this.props.confirmDeleteTeam(
                        row.id,
                        row.teamId,
                        this.props.keyIdfr,
                        RemoveActionType.Delete
                      );
                      this.props.setCurrentTeamInfo(row.teamName, row.id);
                    }
                  }}
                >
                  Delete
                  <i
                    title="Remove"
                    className="fas fa-trash-alt cursorPointer cursorPointer pl-2"
                    //style={{ marginLeft: "10%" }}
                  ></i>
                </button>
              )}
            </>
          );
        },
      };

      columnsToRender.push(actionCol);
      //columnsToRender.push(deleteCol);
      if (
        this.props.emailListMemType == EmailListMemType.NonNatcaUnSubscribers
      ) {
        columnsToRender = columnsToRender.filter(
          (f) => f.dataField != "facilityRegion"
        );
      }

      const customTotal = (from, to, size) => (
        <span
          className="react-bootstrap-table-pagination-total"
          style={{ float: "left", marginTop: "3px", marginRight: "4px" }}
        >
          {from}
          {" - "}
          {to} of {size} {"   "}
          <b style={{ marginLeft: "4px" }}> Show: </b>
        </span>
      );
      return (
        <div
          className="table-responsive scroller"
          ref={(node) => {
            if (node) {
              node.style.setProperty("min-height", "auto", "important");
            }
          }}
          key={this.props.emailListMemType}
        >
          <ToolkitProvider
            keyField={
              this.props.emailListMemType ==
              EmailListMemType.AdditionalTeamUnSubscribers
                ? `teamId`
                : `address`
            }
            data={unsubscriberList}
            columns={columnsToRender}
          >
            {(props) => (
              <>
                <BootstrapTable
                  noDataIndication={() => {
                    return loading === false ? (
                      <NoDataIndication />
                    ) : (
                      <div className="d-flex justify-content-center p-4">
                        <Spinner />
                      </div>
                    );
                  }}
                  pagination={paginationFactory({
                    ...{
                      paginationTotalRenderer: customTotal,
                      totalSize: unsubscriberList && unsubscriberList.length,
                      paginationTotalRenderer: TableCustomTotal,
                      showTotal: true,
                      page,
                      sizePerPage,
                      sizePerPageList,
                    },
                  })}
                  // overlay={
                  //   !_.isEmpty(unsubscriberList)
                  //     ? overlayFactory({
                  //         spinner: true,
                  //         styles: {
                  //           overlay: (base) => ({
                  //             ...base,
                  //             background: "rgba(40, 45, 42, 0.19)",
                  //           }),
                  //         },
                  //       })
                  //     : null
                  // }
                  expandRow={this.props.isTeamsTable ? this.expandRow : {}}
                  caption={<CaptionElement header={caption} />}
                  {...props.baseProps}
                />
              </>
            )}
          </ToolkitProvider>
        </div>
      );
    }
  };

  handleTextChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSearch = (val, subFlag, emailListMemType) => {
    //alert(`Searching ${val}...`);
    switch (subFlag) {
      case true:
        // this.updateSubscriberList(this.state.listPaging["sub"]);
        this.searchMembersList(val, subFlag, emailListMemType);
        break;
      case false:
        //.updateUnsubscriberList(this.state.listPaging["unsub"]);
        this.searchMembersList(val, subFlag, emailListMemType);
        break;
    }
  };
  searchMembersList = (val, isSub, emailListMemType) => {
    if (isSub) {
      let { allDefaultSubscribers } = this.state;
      let filteredData = allDefaultSubscribers.filter(
        (x) =>
          _.toLower(x.name).includes(_.toLower(val.toLowerCase() || "")) ||
          _.toLower(x.address).includes(_.toLower(val.toLowerCase() || ""))
      );
      this.setState({ subscribers: filteredData });
    } else if (!isSub) {
      if (emailListMemType == EmailListMemType.UnSubscribers) {
        let { allDefaultUnSubscribers } = this.state;
        let filteredData = allDefaultUnSubscribers.filter(
          (x) =>
            _.toLower(x.name).includes(_.toLower(val.toLowerCase() || "")) ||
            _.toLower(x.address).includes(_.toLower(val.toLowerCase() || ""))
        );
        this.setState({ unsubscribers: filteredData });
      } else if (emailListMemType == EmailListMemType.NonNatcaUnSubscribers) {
        let { allDefaultNonNatcaUnSubscribers } = this.state;
        let filteredData = allDefaultNonNatcaUnSubscribers.filter(
          (x) =>
            _.toLower(x.name).includes(_.toLower(val.toLowerCase() || "")) ||
            _.toLower(x.address).includes(_.toLower(val.toLowerCase() || ""))
        );
        this.setState({ nonNatcaUnsubscribers: filteredData });
      } else if (
        emailListMemType == EmailListMemType.AdditionalTeamUnSubscribers
      ) {
        let { allDefaultAdditionalTeamUnSubscribers } = this.state;
        let filteredData = allDefaultAdditionalTeamUnSubscribers.filter(
          (x) =>
            _.toLower(x.name).includes(_.toLower(val.toLowerCase() || "")) ||
            _.toLower(x.address).includes(_.toLower(val.toLowerCase() || ""))
        );
        this.setState({ additionalTeamUnSubscribers: filteredData });
      }
    }
  };
  toggleUnSubscriber = () => {
    if (this.state.toggleUNSUB === true) {
      this.setState({ toggleUNSUB: false });
    } else {
      this.setState({ toggleUNSUB: true });
    }
  };

  toggleSubscriber = () => {
    if (this.state.toggleSUB === true) {
      this.setState({ toggleSUB: false });
    } else {
      this.setState({ toggleSUB: true });
    }
  };
  render() {
    let {
      subscribers,
      totalSubscribers,
      nonNatcaUnSubscribers,
      additionalTeamUnSubscribers,
      unsubscribers,
      //totalUnsubscribers,
    } = this.state;
    let { hideActionColumn } = this.props;
    return (
      <AUX>
        <Accordion defaultActiveKey="1">
          {this.props.emailListMemType == EmailListMemType.Subscribers && (
            <Card>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  <div class="row">
                    {totalSubscribers !== 0 && (
                      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div className="input-group width100">
                          <input
                            name="subSearchText"
                            type="text"
                            id="subSearchText"
                            value={this.state.subSearchText}
                            onChange={this.handleTextChange}
                            onKeyUp={(e) => {
                              if (e.keyCode === 13) {
                                this.handleSearch(
                                  e.target.value,
                                  true,
                                  this.props.emailListMemType
                                );
                              }
                            }}
                            className="form-control MemberSearchField"
                            placeholder="Search Subscriber"
                          />
                          <div className="input-group-append">
                            <button
                              type="submit"
                              className="topBarSearchBtn"
                              title="Search subscriber now"
                              onClick={(e) => {
                                let { subSearchText } = this.state;
                                this.handleSearch(
                                  subSearchText,
                                  true,
                                  this.props.emailListMemType
                                );
                              }}
                            >
                              <i className="fa fa-search" />
                            </button>
                          </div>
                          {/* <small className="text-danger w-100">
                    {this.state.memberSearchText_err}
                  </small> */}
                        </div>
                      </div>
                    )}
                    {/* ///The first Lists Showed for Default Subscribers/// */}
                    <div class="col-12">
                      {this.renderSubscribed(
                        subscribers,
                        1,
                        10,
                        this.state.loadingSubs
                      )}

                      {/* {totalSubscribers == 0 && !this.state.loadingSubs && (
                        <div class="container h-100">
                          <div class="row NoDataFoundTable">
                            <h5>No Data Found!</h5>
                          </div>
                        </div>
                      )}

                      {this.state.loadingSubs && (
                        <div className="d-flex justify-content-center p-4">
                          <Spinner />
                        </div>
                      )} */}
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          )}

          {/* ####################################Start of Un Subscribers Tabs################################# */}
          {this.props.emailListMemType == EmailListMemType.UnSubscribers && (
            <Accordion.Collapse eventKey="1">
              <Card>
                <Card.Body>
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pb-2">
                      <div className="input-group width100">
                        <input
                          name="unsubSearchText"
                          type="text"
                          id="unsubSearchText"
                          value={this.state.unsubSearchText}
                          onChange={this.handleTextChange}
                          onKeyUp={(e) => {
                            if (e.keyCode === 13) {
                              this.handleSearch(
                                e.target.value,
                                false,
                                this.props.emailListMemType
                              );
                            }
                          }}
                          className="form-control MemberSearchField"
                          placeholder="Search Unsubscriber"
                        />
                        <div className="input-group-append">
                          <button
                            type="submit"
                            className="topBarSearchBtn"
                            title="Search subscriber now"
                            onClick={(e) => {
                              this.handleSearch(
                                this.state.unsubSearchText,
                                false,
                                this.props.emailListMemType
                              );
                            }}
                          >
                            <i className="fa fa-search" />
                          </button>
                        </div>
                        {/* <small className="text-danger w-100">
                  {this.state.memberSearchText_err}
                </small> */}
                      </div>
                    </div>

                    <div class="col-12">
                      {this.renderUnsubscribed(
                        unsubscribers,
                        1,
                        10,
                        this.state.loadingUnSubs,
                        "NATCA MEMBERS",
                        hideActionColumn
                      )}
                    </div>

                    {/* {totalUnsubscribers == 0 && !this.state.loadingUnSubs && (
                      <div class="container h-100">
                        <div class="row NoDataFoundTable">
                          <h5>No Data Found!</h5>
                        </div>
                      </div>
                    )} */}
                  </div>
                </Card.Body>
              </Card>
            </Accordion.Collapse>
          )}

          {this.props.emailListMemType ==
            EmailListMemType.NonNatcaUnSubscribers &&
            AuthService.canView(PermissionFeature.EmailAddlSubscribersList) && (
              <>
                <Accordion.Collapse eventKey="1">
                  <Card>
                    <Card.Body>
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pb-2">
                          <div className="input-group width100">
                            <input
                              name="nonNatcaUnsubSearchText"
                              type="text"
                              id="nonNatcaUnsubSearchText"
                              value={this.state.nonNatcaUnsubSearchText}
                              onChange={this.handleTextChange}
                              onKeyUp={(e) => {
                                if (e.keyCode === 13) {
                                  this.handleSearch(
                                    e.target.value,
                                    false,
                                    this.props.emailListMemType
                                  );
                                }
                              }}
                              className="form-control MemberSearchField"
                              placeholder="Search Non Natca Unsubscribers"
                            />
                            <div className="input-group-append">
                              <button
                                type="submit"
                                className="topBarSearchBtn"
                                title="Search subscriber now"
                                onClick={(e) => {
                                  this.handleSearch(
                                    this.state.nonNatcaUnsubSearchText,
                                    false,
                                    this.props.emailListMemType
                                  );
                                }}
                              >
                                <i className="fa fa-search" />
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="col-12 NON-NATCA">
                          {this.renderUnsubscribed(
                            nonNatcaUnSubscribers,
                            1,
                            10,
                            this.state.loadingNonNatcaUnSubs,
                            "NON-NATCA",
                            hideActionColumn
                          )}
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Accordion.Collapse>

                <>
                  {/* {this.state.loadingNonNatcaUnSubs && (
                  <div className="d-flex justify-content-center p-4">
                    <Spinner />
                  </div>
                )} */}
                  {/* {totalNonNatcaUnsubscribers == 0 &&
                  !this.state.loadingNonNatcaUnSubs && (
                    <Card>
                      <Card.Body>
                        <div className="table">
                          <div class="row noData flex-column">
                            <caption>
                              <h6 class="sub_tbl_caption">NON-NATCA</h6>
                            </caption>
                          </div>
                          <div class="container h-100">
                            <div class="row NoDataFoundTable">
                              <h5>No Data Found!</h5>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  )} */}
                </>
              </>
            )}

          {this.props.emailListMemType ==
            EmailListMemType.AdditionalTeamUnSubscribers &&
            AuthService.canView(PermissionFeature.EmailAddlSubscribersList) && (
              <>
                <Accordion.Collapse eventKey="1">
                  <Card>
                    <Card.Body>
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pb-2">
                          <div className="input-group width100">
                            <input
                              name="additionalUnsubTeamSearchText"
                              type="text"
                              id="additionalUnsubTeamSearchText"
                              value={this.state.nonNatcaUnsubSearchText}
                              onChange={this.handleTextChange}
                              onKeyUp={(e) => {
                                if (e.keyCode === 13) {
                                  this.handleSearch(
                                    e.target.value,
                                    false,
                                    this.props.emailListMemType
                                  );
                                }
                              }}
                              className="form-control MemberSearchField"
                              placeholder="Search Unsubscribed Team"
                            />
                            <div className="input-group-append">
                              <button
                                type="submit"
                                className="topBarSearchBtn"
                                title="Search subscriber now"
                                onClick={(e) => {
                                  this.handleSearch(
                                    this.state.nonNatcaUnsubSearchText,
                                    false,
                                    this.props.emailListMemType
                                  );
                                }}
                              >
                                <i className="fa fa-search" />
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="col-12 NON-NATCA">
                          {this.renderUnsubscribed(
                            additionalTeamUnSubscribers,
                            1,
                            10,
                            this.state.loadingAdditionalTeamUnSubs,
                            "TEAMS",
                            hideActionColumn
                          )}
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Accordion.Collapse>
              </>
            )}
        </Accordion>
        <MG_ReSubscriberModal
          email={this.state.resubscribeEmail}
          teamName={this.state.unSubTeam}
          modal={this.state.showReSubscribeModal}
          confirm={
            this.state.unSubTeam
              ? this.confirmResubscribersModalForTeams
              : this.confirmResubscribersModal
          }
          toggle={this.toggleResubscribersModal}
        />
      </AUX>
    );
  }
}

///export default MailGunMembersList;

export default connect(
  (state) => ({
    melstate: state.mailGunEmail,
  }),
  {
    ...mailGunEmailActions,
  },
  null,
  { forwardRef: true }
)(MailGunMembersList);
